import { PresignedUploadError } from '@/features/statement/statement-upload';
import { api } from '@/lib/api';

/**
 * Ask for the upload, send the bytes straight to the store, then name the
 * token on the campaign — §5.4's three steps, applied to a picture. The `fetch`
 * carries no credentials because the store is not our API.
 */
export async function uploadCampaignImage(input: { id: string; file: File }) {
  const upload = await api.campaign.requestImageUpload({
    id: input.id,
    fileName: input.file.name,
    fileSize: input.file.size,
  });

  const response = await fetch(upload.uploadUrl, {
    method: 'PUT',
    body: input.file,
    credentials: 'omit',
  });
  if (!response.ok) throw new PresignedUploadError(response.status);

  return api.campaign.setImage({ id: input.id, uploadToken: upload.uploadToken });
}
